
import { OverlayTrigger, Popover } from "react-bootstrap";
import { CategoryIcon, MediaTemplate } from "./styled";


export function MediaTooltip(props: any) {

    return (
        <>
            <MediaTemplate>
                <OverlayTrigger
                    placement={'top'}
                    overlay={
                        <Popover id={`popover-positioned-top`} style={{ width: '15%' }}>
                            <Popover.Body >
                                {props.node.data.project &&
                                    <p><b>Projeto:</b> {props.node.data.project}</p>
                                }
                                <p><b>Disciplina:</b> {props.node.data.discipline_name}</p>
                                <p style={{ textAlign: 'left' }}>Tipo do objeto</p>
                                {props.node.data?.category?.category_icon ? (<>
                                    <div style={{ color: '#6473FF' }}>
                                        <CategoryIcon style={{ textAlign: 'left', color: '#6473FF', marginRight: '5px' }} className={`material-icons-${props.node.data.category.category_icon}`}>{props.node.data.category.category_icon.split(' ')[1]}</CategoryIcon>
                                        <span style={{ verticalAlign: 'top' }}>{props.node.data?.category.title}</span>
                                    </div>
                                </>) : (<></>)}
                                {!!props.node.data?.category_value?.length && props.node.data?.category_value?.map((category: any, index: any) => (
                                    <>
                                        <p key={index + category} style={{ marginBottom: '0px', wordBreak: 'break-all' }}><b>{category.title}: </b>{category.value}</p>
                                    </>
                                ))}
                            </Popover.Body>
                        </Popover>
                    }
                >
                    {props.children}
                </OverlayTrigger>
            </MediaTemplate>

        </>
    )
}